import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const MernaJednotka = {
	name: NAME,
	apiProvider,
	router,
};
